import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoRadPesquisaPreFaturaUnidata({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'radpesquisaprefaturaunidata', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoRadPesquisaPreFaturaUnidata({ payload }) {
  try {
    const { fatu_codigo, params } = payload;

    yield call(api.delete, `radpesquisaprefaturaunidata/${fatu_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoradpesquisaprefaturaunidata, params } = payload;

    yield call(
      api.post,
      'radpesquisaprefaturaunidata',
      operacaoradpesquisaprefaturaunidata
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/radpesquisaprefaturaunidata');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `radpesquisaprefaturaunidata/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoradpesquisaprefaturaunidata, params } = payload;

    yield call(
      api.put,
      'radpesquisaprefaturaunidata',
      operacaoradpesquisaprefaturaunidata
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/radpesquisaprefaturaunidata');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'radpesquisaprefaturaunidata', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoradpesquisaprefaturaunidata/RADPESQUISAPREFATURAUNIDATA_IN_REQUEST',
    requestOperacaoRadPesquisaPreFaturaUnidata
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturaunidata/DELETE_RADPESQUISAPREFATURAUNIDATA',
    deleteOperacaoRadPesquisaPreFaturaUnidata
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturaunidata/SUCCESS_REMOVE',
    requestOperacaoRadPesquisaPreFaturaUnidata
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturaunidata/STORE_RADPESQUISAPREFATURAUNIDATA',
    store
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturaunidata/FIND_RADPESQUISAPREFATURAUNIDATA',
    find
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturaunidata/UPDATE_RADPESQUISAPREFATURAUNIDATA',
    update
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturaunidata/RECORD_FILTERING',
    applyedFilters
  ),
]);
